import { render, staticRenderFns } from "./OutreachAuthorView.vue?vue&type=template&id=01a4f844&"
import script from "./OutreachAuthorView.vue?vue&type=script&lang=js&"
export * from "./OutreachAuthorView.vue?vue&type=script&lang=js&"
import style0 from "./OutreachAuthorView.vue?vue&type=style&index=0&id=01a4f844&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports